<div class="body-container largeblock">
  <div class="checklist-accordion">
    @if (categories && categories.length > 0) {
    @for (category of categories; track category; let k = $index) {
    <div class="checklist-header">
      {{ category.name }}
    </div>
    <mat-accordion>
      @if (category.checkpoints && category.checkpoints.length > 0) {
      @for (checkpoint of category.checkpoints; track checkpoint; let j = $index) {
      @if (checkpoint.isWalkthroughEnabled) {
      <mat-expansion-panel class="walkthrough-checkpoint">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="radio-button">
              @if (checkpoint.status === 'NotOKRed') {
              <img src="../../assets/common/radio-buttons/not-ok-red.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'NotOK') {
              <img src="../../assets/common/radio-buttons/not-ok.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'OK') {
              <img src="../../assets/common/radio-buttons/ok.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'Undefined') {
              <img src="../../assets/common/radio-buttons/Undefined.svg" alt="File not found." i18n-alt>
              }
            </div>
            {{ checkpoint.description }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="expansion-panel-body">
          <div class="checkpoint-description">
            {{checkpoint.solution?.description}}
          </div>
          <div class="checkpoint-measuredValue">
            {{checkpoint.measuredValues?.[0]?.value}}
          </div>
          @if (checkpoint.comment) {
          <div class="checkpoint-measuredValue">
            {{checkpoint.comment}}
          </div>
          }
          @if (checkpoint?.media?.length?? 0) {
          <div class="carousel-container">
            @if (checkpoint?.media) {
            <p class="gallery" i18n>Gallery</p>
            }
            @if (checkpoint?.media) {
            <div class="media-list">
              @for (item of checkpoint?.media; track item; let j = $index) {
              <div [class.active]="j === 0">
                @if (item.mimeType.includes('video')) {
                <div class="large-screen-media-image">
                  <mat-icon (click)="openMediaPlayerModal(checkpoint?.media, j, checkpoint.isWalkthroughEnabled)"
                    class="mat-play-icon">play_arrow</mat-icon>
                  <a (click)="openMediaPlayerModal(checkpoint?.media, j, checkpoint.isWalkthroughEnabled)">
                    <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                  </a>
                </div>
                }
                @if (item.mimeType.includes('Image')) {
                <div class="large-screen-media-image">
                  <a (click)="openMediaPlayerModal(checkpoint?.media, j, checkpoint.isWalkthroughEnabled)">
                    <img [src]="item.url" alt="File not found." i18n-alt>
                  </a>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
          @if (checkpoint.measuredValues && checkpoint.measuredValues[0]?.media) {
          <div class="carousel-container">
            @if (isDealerBrandingEnabled) {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media"
              [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
            </app-carousel>
            } @else {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media">
            </app-carousel>
            }
          </div>
          }

          @for (findings of checkpoint?.findings; track findings; let l = $index) {
          <div class="findings-container">
            <div class="finding-description">
              {{findings.findingType?.description}}
            </div>
            <div class="finding-solution">
              {{findings.solution?.description}}
            </div>
            <div class="finding-comment">
              {{findings.comment}}
            </div>
            @if (findings.media && findings.media.length>0) {
            <p class="gallery" i18n>Gallery</p>
            }
            @if (findings.media) {
            <div class="media-list">
              @for (item of findings?.media; track item; let j = $index) {
              <div [class.active]="j === 0">
                @if (item.mimeType.includes('video')) {
                <div class="large-screen-media-image">
                  <mat-icon (click)="openMediaPlayerModal(findings.media, j, checkpoint.isWalkthroughEnabled)"
                    class="mat-play-icon">play_arrow</mat-icon>
                  <a (click)="openMediaPlayerModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                    <img [src]="item.thumbnail?.url" alt="File not found." i18n-alt>
                  </a>
                </div>
                }
                @if (item.mimeType.includes('Image')) {
                <div class="large-screen-media-image">
                  <a (click)="openMediaPlayerModal(findings.media, j, checkpoint.isWalkthroughEnabled)">
                    <img [src]="item.url" alt="File not found." i18n-alt>
                  </a>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
      </mat-expansion-panel>
      }
      }
      }
    </mat-accordion>
    }
    }
  </div>
</div>

<div class="body-container small-block">
  <div class="checklist-accordion">
    @if (categories && categories.length > 0) {
    @for (category of categories; track category; let k = $index) {
    <div class="checklist-header">
      {{ category.name }}
    </div>
    <mat-accordion>
      @if (category.checkpoints && category.checkpoints.length > 0) {
      @for (checkpoint of category.checkpoints; track checkpoint; let j = $index) {
      @if (checkpoint.isWalkthroughEnabled) {
      <mat-expansion-panel class="walkthrough-checkpoint">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="radio-button">
              @if (checkpoint.status === 'NotOKRed') {
              <img src="../../assets/common/radio-buttons/not-ok-red.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'NotOK') {
              <img src="../../assets/common/radio-buttons/not-ok.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'OK') {
              <img src="../../assets/common/radio-buttons/ok.svg" alt="File not found." i18n-alt>
              }
              @if (checkpoint.status === 'Undefined') {
              <img src="../../assets/common/radio-buttons/Undefined.svg" alt="File not found." i18n-alt>
              }
            </div>
            {{ checkpoint.description }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="expansion-panel-body">
          <div class="checkpoint-description">
            {{checkpoint.solution?.description}}
          </div>
          <div class="checkpoint-measuredValue">
            {{checkpoint.measuredValues?.[0]?.value}}
          </div>
          @if (checkpoint.comment) {
          <div class="checkpoint-measuredValue">
            {{checkpoint.comment}}
          </div>
          }
          @if (checkpoint?.media?.length ?? 0) {
          <div class="carousel-container">
            @if (isDealerBrandingEnabled) {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.media"
              [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
            </app-carousel>
            } @else {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.media"
              [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled">
            </app-carousel>
            }
          </div>
          }

          @if (checkpoint.measuredValues && checkpoint.measuredValues[0]?.media) {
          <div class="carousel-container">
            @if (isDealerBrandingEnabled) {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media"
              [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
            </app-carousel>
            } @else {
            <app-carousel id="{{j}}{{k}}" [media]="checkpoint.measuredValues[0].media"
              [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled">
            </app-carousel>
            }
          </div>
          }

          @for (findings of checkpoint?.findings; track findings; let l = $index) {
          <div class="findings-container">
            <div class="finding-description">
              {{findings.findingType?.description}}
            </div>
            <div class="finding-solution">
              {{findings.solution?.description}}
            </div>
            <div class="finding-comment">
              {{findings.comment}}
            </div>
            @if (findings.media && findings.media.length > 0) {
            <div class="carousel-container">
              @if (isDealerBrandingEnabled) {
              <app-carousel id="{{j}}{{k}}{{l}}" [media]="findings?.media"
                [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled" [introOutroMediaData]="introOutroMediaData">
              </app-carousel>
              } @else {
              <app-carousel id="{{j}}{{k}}{{l}}" [media]="findings?.media"
                [isWalkthroughEnabled]="checkpoint.isWalkthroughEnabled">
              </app-carousel>
              }
            </div>
            }

          </div>
          }
        </div>
      </mat-expansion-panel>
      }
      }
      }
    </mat-accordion>
    }
    }
  </div>
</div>

<div class="backdrop"></div>
<div class="modal" #imageModal tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title"></div>
        <button (click)="closeMediaPlayerModal()" type="button" class="close">
          <span>&times;</span>
        </button>
      </div>
      <div class="model-media-container">
        <div class="navigation-button">
          <mat-icon class="navigation-left"
            (click)="openMediaPlayerModal(modelMedia, correntSellectedModel-1)">keyboard_arrow_left</mat-icon>
        </div>
        <div class="modal-body">
          @if (mediaElememt === 'image') {
          <img [src]="modalImageUrl" class="d-block w-100" alt="modalImage">
          }
          @if (mediaElememt === 'video' && !(isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
          <video id="model-video" #modelVideo autoplay controls>
            <source [src]="modalImageUrl" type="video/mp4">
            <source [src]="modalImageUrl" type="video/ogg">
            Your browser does not support the video.
          </video>
          }
          @if (mediaElememt === 'video' && (isWalkthroughEnabled && !isObjectEmpty(introOutroMediaData))) {
          <div class="video-player-large-div">
            @for (media of modelMedia; track media; let i = $index) {
            <div class="video-player-large-child-div">
              @if (i == correntSellectedModel) {
              @if (isDealerBrandingEnabled && modelMedia[i]) {
              <app-video-player [media]="modelMedia[i]" [introOutroMediaData]="introOutroMediaData">
              </app-video-player>
              }
              @else if (modelMedia[i]) {
              <app-video-player [media]="modelMedia[i]">
              </app-video-player>
              }
              }
            </div>
            }
          </div>
          }

        </div>
        <div class="navigation-button">
          <mat-icon class="navigation-right"
            (click)="openMediaPlayerModal(modelMedia, correntSellectedModel+1)">keyboard_arrow_right</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>